<!-- src/layouts/UnauthenticatedLayout.vue -->
<template>
    <div class="h-screen flex items-center justify-center">
      <!-- Formulário de Login ou Página de Boas-Vindas -->
      <slot></slot> <!-- Aqui será injetado o conteúdo da página -->
    </div>
  </template>
  
  <script>
  export default {
    name: 'UnauthenticatedLayout',
  };
  </script>
  
  <style scoped>
  /* Adicione seus estilos para o layout não autenticado */
  </style>
  